module.exports = __webpack_public_path__ + "static/media/ke.51dcc7ca.png";